import DSModal from "@/componentsDS/Modal/Modal.jsx";
import DSCardConfigure from "@/componentsDS/Modal/CardConfigure.jsx";
import PropTypes from 'prop-types';

/**
 * Shared scaffold for the small DSV confirm/edit dialogs (Delete draft, Edit
 * version number, ...). Centralises the DSModal + CardConfigure header/body/
 * footer chrome and the standard Cancel button so each concrete modal only
 * supplies its title, body content and primary action.
 */
function DsvModalShell({ visible, hide, title, minWidth = 480, cancelLabel = 'Cancel', actions, children }) {
	return (
		<DSModal visible={visible} close={hide} variant="small" dismissClickOutsideModal={false}>
			<DSCardConfigure style={{ minWidth }}>
				<DSCardConfigure.Header>
					<DSCardConfigure.Header.Title>{title}</DSCardConfigure.Header.Title>
					<DSCardConfigure.Header.Close>
						<button className="dsv-icon-btn" onClick={hide} title="Close">&times;</button>
					</DSCardConfigure.Header.Close>
				</DSCardConfigure.Header>
				<DSCardConfigure.Body>
					<DSCardConfigure.Body.Col>
						{children}
					</DSCardConfigure.Body.Col>
				</DSCardConfigure.Body>
				<DSCardConfigure.Footer>
					<DSCardConfigure.Footer.Left />
					<DSCardConfigure.Footer.Right>
						<button className="dsv-btn dsv-btn--ghost" onClick={hide}>{cancelLabel}</button>
						{actions}
					</DSCardConfigure.Footer.Right>
				</DSCardConfigure.Footer>
			</DSCardConfigure>
		</DSModal>
	);
}

DsvModalShell.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func,
	title: PropTypes.node,
	minWidth: PropTypes.number,
	cancelLabel: PropTypes.string,
	actions: PropTypes.node,
	children: PropTypes.node,
};

export default DsvModalShell;
